import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable ,  Subject } from 'rxjs';
import { BackendService } from '../core/backend.service';
import { ModelStatus } from '../viewmodels/model-status';
import { PlannedMaintenanceLibraryItem } from '../viewmodels/planned-maintenance/planned-maintenance-library-item';

@Injectable()
export class PlannedMaintenanceLibraryService {
  public selectedItemChanged: Subject<any> = new Subject<any>();
  public selectedItemIsEditable: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public saveComplete: Subject<PlannedMaintenanceLibraryItem> = new Subject<PlannedMaintenanceLibraryItem>();
  public libraryItemLoaded = new Subject<PlannedMaintenanceLibraryItem>();

  constructor(private backendService: BackendService) {}

  getAll(): Observable<PlannedMaintenanceLibraryItem[]> {
    return this.backendService.getAll<PlannedMaintenanceLibraryItem>(PlannedMaintenanceLibraryItem).pipe(map(libraryItems => libraryItems));
  }

  getPlannedMaintenance(plannedMaintenanceId: string): Observable<PlannedMaintenanceLibraryItem> {
    return this.backendService.getById<PlannedMaintenanceLibraryItem>(PlannedMaintenanceLibraryItem, plannedMaintenanceId).pipe(map(data => data));
  }

  setSelectedItemEditable(plannedMaintenanceItem: PlannedMaintenanceLibraryItem) {
    const canEdit: boolean = plannedMaintenanceItem.status === ModelStatus.Draft;
    this.selectedItemIsEditable.next(canEdit);
  }

  save(maintenanceItem: PlannedMaintenanceLibraryItem): Observable<PlannedMaintenanceLibraryItem> {
    if (maintenanceItem.id) {
      return this.backendService
        .update<PlannedMaintenanceLibraryItem>(PlannedMaintenanceLibraryItem, maintenanceItem.id, maintenanceItem).pipe(
        map(result => {
          if (result) {
            this.saveComplete.next(result);
            return result;
          }
        }));
    } else {
      return this.backendService.create<PlannedMaintenanceLibraryItem>(PlannedMaintenanceLibraryItem, maintenanceItem).pipe(map(result => {
        if (result) {
          this.selectedItemChanged.next(result.id);
          this.saveComplete.next(result);
          return result;
        }
      }));
    }
  }
}
